import { DISPLAY_CURRENCIES, useDisplayCurrency } from "../../contexts/DisplayCurrencyContext"

export default function CurrencySelector() {
  const { currency, selectCurrency, loading, error, rates, retry } = useDisplayCurrency()
  const unavailable = Boolean(currency && !loading && !rates[currency])
  return (
    <div className="w-full min-w-0 text-gray-700">
      <label htmlFor="display-currency" className="mb-1 block text-xs font-medium">Additional currency</label>
      <select id="display-currency" value={currency} onChange={event => selectCurrency(event.target.value)}
        className="w-full rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-dantzBlue/30">
        <option value="">EUR only</option>
        {DISPLAY_CURRENCIES.map(([code, name]) => <option key={code} value={code}>{code} – {name}</option>)}
      </select>
      <p className="mt-1 text-[10px] leading-snug text-gray-500">Estimates only. Invoices and payments are always in EUR.</p>
      {currency && <p role="status" className="mt-1 text-[10px] text-gray-500">
        {loading ? "Loading exchange rates…" : error || unavailable ? "Conversion unavailable. Prices remain in EUR." : `Rate as of ${rates[currency]?.date} · Frankfurter`}
      </p>}
      {currency && (error || unavailable) && !loading && <button type="button" className="mt-1 text-xs underline" onClick={retry}>Try again</button>}
    </div>
  )
}
